import React, { useState, useEffect } from "react";
import Tab from "react-bootstrap/Tab";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Nav from "react-bootstrap/Nav";

import TimeslotsContainer from "./TimeslotsContainer";
import DeliveriesContainer from "./DeliveriesContainer";
import moment from "moment";
import LogisticsContainer from "./LogisticsContainer";

const LogisticsTabs = ({ match, history }) => {
  const [key, setKey] = useState(match.params.tab || "deliveries");
  const [selectedDate, setSelectedDate] = useState(
    match.params.date || moment(Date.Now).format("YYYY-MM-DD")
  );
  const handleSelect = (k) => {
    setKey(k);
    history.push(`/logistics/${k}/${selectedDate}`);
  };
  useEffect(() => {
    history.push(`/logistics/${key}/${selectedDate}`);
  }, [selectedDate]);
  return (
    <Tab.Container
      className="mt-2"
      id="logisticsTabs"
      activeKey={key}
      onSelect={(k) => handleSelect(k)}
      mountOnEnter
      unmountOnExit
    >
      <Row>
        <Col sm={1} className="pt-5">
          <Nav variant="tabs" className="flex-column">
            <Nav.Item>
              <Nav.Link eventKey="fulfillments">Fulfillments </Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link eventKey="fulfillmarkers">
                Fulfillments on Map{" "}
              </Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link eventKey="deliveries">Deliveries </Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link eventKey="timeslots">Timeslots</Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link eventKey="routes">Routes </Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link eventKey="createRouteMap">Create Route Map</Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link eventKey="cancelled">Cancelled Deliveries </Nav.Link>
            </Nav.Item>
            {/* )} */}
            <Nav.Item>
              <Nav.Link eventKey="instructions">Delivery Instructions</Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link eventKey="awaiting">Unfinished Deliveries </Nav.Link>
            </Nav.Item>
          </Nav>
        </Col>
        <Col sm={11}>
          <div className="container-fluid">
            <Tab.Content>
              <Tab.Pane mountOnEnter unmountOnExit eventKey="fulfillments">
                <LogisticsContainer tab="fulfillments" />
              </Tab.Pane>
              <Tab.Pane mountOnEnter unmountOnExit eventKey="fulfillmarkers">
                <LogisticsContainer tab="fulfillmarkers" />
              </Tab.Pane>
              <Tab.Pane eventKey="deliveries">
                <DeliveriesContainer
                  tab="deliveries"
                  selectedDate={selectedDate}
                  setSelectedDate={setSelectedDate}
                />
              </Tab.Pane>
              <Tab.Pane eventKey="cancelled">
                <LogisticsContainer tab="cancelled" />
              </Tab.Pane>
              <Tab.Pane eventKey="instructions">
                <DeliveriesContainer
                  tab="instructions"
                  selectedDate={selectedDate}
                  setSelectedDate={setSelectedDate}
                />
              </Tab.Pane>
              <Tab.Pane eventKey="createRouteMap">
                <DeliveriesContainer
                  tab="create_routes"
                  selectedDate={selectedDate}
                  setSelectedDate={setSelectedDate}
                />
              </Tab.Pane>
              <Tab.Pane eventKey="routes">
                <DeliveriesContainer
                  tab="routes"
                  selectedDate={selectedDate}
                  setSelectedDate={setSelectedDate}
                />
              </Tab.Pane>
              <Tab.Pane eventKey="awaiting">
                <LogisticsContainer tab="awaiting" />
              </Tab.Pane>
              <Tab.Pane eventKey="timeslots">
                <TimeslotsContainer
                  selectedDate={selectedDate}
                  setSelectedDate={setSelectedDate}
                />
              </Tab.Pane>
            </Tab.Content>
          </div>
        </Col>
      </Row>
    </Tab.Container>
  );
};

export default LogisticsTabs;
